{
  "fleetSizeQuestion": "Quantos motoristas você tem hoje na sua frota?",
  "fleetSizeHint": "Só para conhecermos a sua operação — você vai escolher as licenças a ativar no próximo passo.",
  "fleetSizeOptionDrivers": "{{range}} motoristas",
  "fleetSizeSaveError": "Não foi possível salvar. Tente novamente.",
  "productQuestion": "Qual produto você quer ativar?",
  "productHint": "Escolha um produto agora — você pode combinar diferente depois no painel.",
  "productOption_hours": "Horas",
  "productOption_hoursDescription": "Registra horários, pausas e descansos do motorista, facilita a conformidade legal e substitui o registro manual.",
  "productOption_gps": "GPS",
  "productOption_gpsDescription": "Localiza veículos em tempo real e ajuda a acompanhar a operação e a responder a imprevistos.",
  "productOption_combo": "Horas + GPS (Combo)",
  "productOption_comboDescription": "Reúne o controle de horas e a localização em tempo real para gerir conformidade e operação no mesmo serviço.",
  "licensesQuestion": "Quantas licenças você quer ativar agora?",
  "licensesHint": "Você pode ativar menos licenças do que motoristas — e adicionar mais a qualquer momento.",
  "licensesSuggested": "Sugestão para {{range}} motoristas: {{count}}",
  "licensesInvalid": "Informe um número entre 1 e {{max}}.",
  "licensesInputLabel": "Número de licenças",
  "licensesIncrease": "Aumentar licenças",
  "licensesDecrease": "Diminuir licenças",
  "licensesTrialNoCard": "Teste grátis de {{days}} dias — sem cartão para começar.",
  "trialCardUpfront": "Teste grátis de {{days}} dias — o cartão é pedido já, mas só é cobrado no fim do teste.",
  "licensesAnswer": "{{count}} licenças",
  "startFreeTrial": "Começar teste grátis",
  "loading": "Carregando…",
  "stripeLoadErrorTitle": "Não foi possível carregar o pagamento seguro",
  "stripeLoadErrorMessage": "O bloqueador de anúncios, a rede ou o CDN do Stripe pode ter impedido o carregamento. Tente novamente ou entre em contato com o suporte para concluir a compra.",
  "tryAgain": "Tentar novamente",
  "contactSupport": "Contatar suporte",
  "gpsContractAcceptErrorTitle": "Não foi possível aceitar o contrato",
  "gpsContractAcceptErrorMessage": "Ocorreu um erro ao registrar a aceitação do contrato GPS. Tente novamente; se persistir, entre em contato com o suporte.",
  "gpsContractLoadError": "Não foi possível carregar o contrato GPS. Tente novamente.",
  "gpsContractVersionChangedTitle": "O contrato foi atualizado",
  "gpsContractVersionChangedMessage": "Uma nova versão do contrato GPS foi publicada. Leia a versão apresentada antes de aceitar.",
  "onboardingWelcomeTitle": "Bem-vindo ao nosso aplicativo!",
  "onboardingWelcomeDescription": "Vamos configurar algumas informações importantes antes de começar. Isso nos ajudará a personalizar sua experiência.",
  "onboardingTitle": "Configuração Inicial",
  "continue": "Continuar",
  "employmentTitle": "Informação de Emprego",
  "loadingEmploymentInfo": "Carregando informações...",
  "employmentDataFound": "Encontramos suas informações de emprego:",
  "edit": "Editar",
  "retry": "Tentar Novamente",
  "networkError": "Não foi possível carregar os dados de emprego. Verifique sua conexão com a internet e tente novamente.",
  "employmentFormIntro": "Por favor, forneça informações sobre seu emprego:",
  "companyName": "Nome da Empresa",
  "companyNipc": "NIF/NIPC da Empresa",
  "nipcError": "O NIF/NIPC deve conter 9 dígitos",
  "companyEmail": "E-mail da Empresa",
  "companyPhone": "Telefone da Empresa",
  "payerQuestion": "Quem paga a licença de trabalho?",
  "payerCompany": "Minha empresa paga",
  "payerSelf": "Eu pago a minha licença",
  "payerRequired": "Escolha quem paga.",
  "permissionsTitle": "Permissões do Aplicativo",
  "permissionsDescription": "Para oferecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermission": "Notificações",
  "notificationsPermissionMessage": "Para receber notificações, você precisa habilitar esta permissão nas configurações do seu dispositivo.",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationPermission": "Localização",
  "locationPermissionMessage": "Para usar sua localização atual, você precisa habilitar esta permissão nas configurações do seu dispositivo.",
  "locationForegroundPermissionTitle": "Localização (Em uso)",
  "locationForegroundPermissionDescription": "Para mostrar sua localização atual no mapa",
  "backgroundLocationPermission": "Localização (Segundo plano)",
  "backgroundLocationPermissionMessage": "Para usar sua localização em segundo plano, você precisa habilitar esta permissão nas configurações do seu dispositivo. Certifique-se de selecionar 'Sempre permitir' para o aplicativo funcionar corretamente.",
  "locationBackgroundError": "Permissão necessária",
  "locationBackgroundErrorMessage": "Você precisa habilitar a localização em primeiro plano antes de habilitar em segundo plano.",
  "locationBackgroundPermissionImportant": "Importante: Para receber notificações quando você estiver parado no mesmo local por um tempo, selecione 'Sempre permitir' nas configurações de localização do seu dispositivo.",
  "finish": "Concluir",
  "ownerWelcomeTitle": "Experimente a solução definitiva de gestão de frotas!",
  "ownerWelcomeDescription": "Controle horas de trabalho e rastreie veículos em tempo real com GPS. Otimize operações e garanta conformidade sem esforço.",
  "ownerFeaturesTitle": "Principais Recursos",
  "ownerFeatureLiveTracking": "Rastreamento de dispositivos GPS com mapa ao vivo",
  "ownerFeatureReports": "Registo automático de horas e relatórios de conformidade",
  "ownerFeatureLicense": "Licenças separadas para Horas e GPS",
  "reviewSetupTotal": "Instalação cobrada uma vez: {{total}}.",
  "licensesShort": "licenças",
  "eligibilityUnavailable": "Não foi possível validar a elegibilidade deste plano. Nenhuma cobrança foi iniciada.",
  "processing": "Processando…",
  "trialDescription": "Você será encaminhado para o pagamento seguro para concluir a assinatura.",
  "paymentDescription": "Você será encaminhado para o pagamento seguro para concluir a compra.",
  "cancel": "Cancelar",
  "continueToTrial": "Continuar para o teste",
  "planType": {
    "hours": "Horas",
    "gps": "GPS",
    "combo": "Combo (Horas + GPS)"
  },
  "ownerTrialButton": "Inicie Seu Teste Gratuito",
  "trialModalTitle": "Inicie seu teste gratuito de 7 dias",
  "trialModalDescription": "Insira seus dados de pagamento para iniciar um período de teste gratuito de 7 dias. Você só será cobrado quando ele terminar.",
  "trialError": "Ocorreu um erro",
  "trialProcessing": "Processando...",
  "trialStartButton": "Iniciar Teste Gratuito",
  "paymentModalTitle": "Concluir a compra",
  "completePurchase": "Concluir compra",
  "paymentProcessing": "Seu pagamento está sendo processado. Atualizaremos a assinatura quando estiver concluída.",
  "paymentError": "Ocorreu um erro. Tente novamente.",
  "paymentErrors": {
    "noStoredPlan": "Não foi possível recuperar o plano selecionado.",
    "trialSubscriptionFailed": "Não foi possível iniciar o teste grátis.",
    "subscriptionIdMissing": "Não foi possível identificar a assinatura.",
    "confirmPaymentFailed": "Não foi possível confirmar o pagamento."
  },
  "supportEmailSubject": "AllDrivers - checkout Stripe indisponível",
  "errorOpeningPortal": "Não foi possível abrir o portal Stripe.",
  "noPlansAvailable": "Nenhum plano disponível",
  "manageInStripe": "Gerenciar no Stripe",
  "interval": {
    "month": "mês",
    "year": "ano"
  },
  "buyLicense": {
    "setupFee": "Taxa de instalação",
    "once": "uma vez",
    "monthlyAmount": "Valor mensal",
    "selectQuantity": "De quantas licenças você precisa?",
    "quantity": "Número de licenças",
    "summary": "Resumo do pedido",
    "plan": "Plano",
    "licenses": "Licenças",
    "total": "Total",
    "totalFirstInvoice": "Total (1ª fatura)"
  },
  "checkoutReturn": {
    "checkingTitle": "Confirmando o pagamento",
    "checkingDescription": "Estamos verificando o resultado do checkout.",
    "successTitle": "Pagamento realizado com sucesso!",
    "successDescription": "Sua licença está ativa e você pode acessar o painel.",
    "pendingTitle": "Processando o pagamento",
    "pendingDescription": "Estamos confirmando seu pagamento. Pode levar alguns instantes — atualize em breve e fale com o suporte se a licença não ficar ativa.",
    "canceledTitle": "Pagamento cancelado",
    "canceledDescription": "Você cancelou o checkout. Pode ativar sua licença quando quiser.",
    "retry": "Tentar novamente",
    "errorTitle": "Não foi possível confirmar o pagamento",
    "errorDescription": "Não conseguimos validar o retorno do checkout. Se já pagou, aguarde alguns minutos ou fale com o suporte.",
    "returnToDashboard": "Ir para o painel"
  },
  "retryPayment": "Tentar novamente",
  "errorFetchingPlans": "Erro ao buscar planos de assinatura",
  "ownerDashboard": {
    "choosePlan": "Escolha seu plano",
    "save10Percent": "Economize 10% com o plano anual",
    "14daystrial": "Teste grátis de 7 dias",
    "startTrial": "Iniciar teste de 7 dias",
    "buyNow": "Comprar Agora",
    "activeDrivers": "Motoristas Ativos",
    "hoursLicenses": "Licenças de Horas",
    "availableHoursLicenses": "Horas Disponíveis",
    "gpsLicenses": "Licenças GPS",
    "availableGpsLicenses": "GPS Disponíveis",
    "companyStats": "Estatísticas da Empresa",
    "dau": "Motoristas Ativos Diariamente",
    "mau": "Motoristas Ativos Mensalmente",
    "employmentsVsLicenses": "Empregos Ativos vs Licenças de Motorista",
    "unassignedDrivers": "Motoristas Ativos sem Atribuição",
    "last12Periods": "últimos 12 períodos",
    "last6Weeks": "últimas 6 semanas",
    "unpaidInvoices": "Faturas em Aberto",
    "oldestVehicles": "Veículos Mais Antigos",
    "highOdometer": "Veículos com Maior Odômetro",
    "invitations": "Convites (7/30 dias)",
    "sentAcceptedExpired": "enviados/aceitos/expirados",
    "inviteDriver": "Convidar Motorista",
    "inviteDriverDesc": "Envie convites para novos motoristas",
    "buyLicenses": "Comprar Licenças",
    "buyLicensesDesc": "Adquira licenças adicionais de motorista",
    "today": "Hoje",
    "average": "Média",
    "latest": "Mais recente",
    "last12Days": "últimos 12 dias",
    "last12Months": "últimos 12 meses"
  },
  "planQuestion": "Você prefere cobrança mensal ou anual?",
  "planHint": "Os preços e a elegibilidade do teste vêm do catálogo atual. Escolha mensal ou anual.",
  "planMonthlyTitle": "Mensal",
  "planAnnualTitle": "Anual",
  "selectPlan": "Selecionar",
  "planMonthlyValue": "{{price}} por licença/mês",
  "planAnnualValue": "{{price}} por licença/ano",
  "planTrialEligible": "Teste grátis de {{days}} dias, sem cartão.",
  "planSetupUnit": "Instalação: {{price}} por veículo, cobrada uma vez.",
  "planAnnualSaving": "Economize {{save}} por licença/ano.",
  "planEligibilityLoading": "Validando as condições do plano…",
  "planCycleUnavailable": "Indisponível no catálogo atual.",
  "planUnavailable": "Este produto está temporariamente indisponível porque o catálogo não tem todas as condições necessárias.",
  "reviewSelection": "Revisar valores",
  "reviewTitle": "Resumo antes de confirmar",
  "reviewProduct": "Produto: {{product}}",
  "reviewRecurringCalculation": "{{quantity}} × {{unit}} = {{total}} recorrentes por {{period}}.",
  "reviewSetupCalculation": "{{quantity}} × {{unit}} = {{total}} de instalação, cobrada uma vez.",
  "reviewAnnualSaving": "Economize {{unitSave}} por licença ({{totalSave}} no total) em comparação com 12 mensalidades.",
  "reviewChargedToday": "Total cobrado hoje: {{total}}.",
  "reviewNextChargeAfterTrial": "Próxima cobrança: {{total}} após {{days}} dias; depois, todos os meses.",
  "reviewNextCharge": "Próxima cobrança recorrente: {{total}} no próximo {{period}}.",
  "periodMonth": "mês",
  "periodYear": "ano",
  "vatIncluded": "IVA incluído.",
  "startTrialCta": "Começar teste grátis",
  "continueToPayment": "Continuar para pagamento",
  "checkoutSelectionInvalid": "A seleção do chat não corresponde ao catálogo atual. Volte ao chat e escolha novamente.",
  "checkoutEligibilityUnavailable": "Não foi possível validar a elegibilidade desta seleção. Tente novamente.",
  "checkoutSelectionDetails": "{{licenses}} licenças · {{billing}} · {{price}} por licença",
  "checkoutSetupFee": "Instalação: {{price}} por veículo, cobrada uma vez.",
  "returnToChat": "Voltar ao chat",
  "purchaseSuccess": "Compra iniciada com sucesso.",
  "subscriptionError": "Não foi possível iniciar a assinatura.",
  "purchaseFailed": "Não foi possível concluir a compra. Tente novamente.",
  "purchaseCancelled": "Pagamento cancelado ou não confirmado. Tente novamente ou volte ao chat.",
  "paymentSelectionInvalid": "A seleção de checkout é inválida.",
  "billing": {
    "monthly": "mensal",
    "annual": "anual"
  },
  "common": {
    "invite": "Convidar",
    "buy": "Comprar",
    "knowMore": "Saiba Mais"
  },
  "productOption_hoursShort": "Registro de horas e descansos.",
  "productOption_gpsShort": "Localização dos veículos em tempo real.",
  "productOption_comboShort": "Horas e GPS no mesmo serviço.",
  "productCardPricing": "{{monthly}}/mês · {{annualMonthly}}/mês no anual",
  "productCardPricingMonthlyOnly": "{{monthly}}/mês",
  "productCardAnnualBilled": "Faturado anualmente a {{total}}",
  "changeProduct": "Alterar produto",
  "viewDetails": "Ver detalhes",
  "hideDetails": "Ocultar detalhes",
  "driverSingleLicense": "1 licença — a sua.",
  "referralAttribution": "Indicação: {{partner}}",
  "registrationOnlyCta": "Continuar só com o cadastro",
  "registrationOnlyHint": "Conclui o cadastro sem ativar licenças. Você pode comprar licenças depois no painel.",
  "registrationOnlyError": "Não foi possível concluir o cadastro. Tente novamente.",
  "gpsContractDeclinedMessage": "Você não aceitou o contrato do GPS, por isso nada foi cobrado. O GPS precisa do contrato; você pode continuar só com o Controle de Horas.",
  "gpsContractDeclinedHoursOnly": "Continuar só com Controle de Horas",
  "gpsContractDeclinedReview": "Revisar o contrato",
  "gpsContractDeclinedSwitchError": "Não foi possível mudar para o Controle de Horas. Tente novamente."
}
